// @noflow
import React, { createContext } from 'react';

export interface QuoteContext {
  applyUrl: string;
  setApplyUrl: (currentUrl: string) => void;
}

const QUOTE_DEFAULT_VALUES = {
  applyUrl: '/',
  setApplyUrl: () => {}
};

const SoftQuoteContext = createContext<QuoteContext>(QUOTE_DEFAULT_VALUES);

export default SoftQuoteContext;
